var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 336V496H16V336H496Z",
    fill: "#E32D3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 176V336H16V176H496Z",
    fill: "#2980B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16V176H16V16H496Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.285 364.4C102.925 347.949 58.0669 315.297 58.0669 250.707C58.0669 186.117 60.9025 156.742 60.9025 156.742H134.285H207.668C207.668 156.742 210.505 186.117 210.505 250.707C210.505 315.297 165.647 347.949 134.285 364.4Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.285 355.826C105.514 340.734 64.3604 310.778 64.3604 251.52C64.3604 192.263 66.9617 165.314 66.9617 165.314H134.285H201.61C201.61 165.314 204.212 192.263 204.212 251.52C204.212 310.777 163.058 340.734 134.285 355.826H134.285Z",
    fill: "#E32D3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.438 235.985C148.228 236.122 163.427 236.454 176.961 231.522C176.961 231.522 176.604 236.796 176.604 242.94C176.604 249.086 176.961 254.36 176.961 254.36C164.547 249.835 149.217 249.741 140.438 249.862V282.592H128.133V249.862C119.354 249.741 104.024 249.835 91.6099 254.359C91.6099 254.359 91.9673 249.085 91.9673 242.94C91.9673 236.796 91.6099 231.522 91.6099 231.522C105.144 236.454 120.343 236.121 128.133 235.984V215.43C121.033 215.361 110.801 215.73 99.2323 219.946C99.2323 219.946 99.5898 214.672 99.5898 208.527C99.5898 202.383 99.2323 197.108 99.2323 197.108C110.784 201.317 121.003 201.693 128.101 201.626C127.736 188.609 124.254 172.203 124.254 172.203C124.254 172.203 131.42 172.812 134.285 172.812C137.152 172.812 144.316 172.203 144.316 172.203C144.316 172.203 140.835 188.609 140.47 201.625C147.568 201.692 157.787 201.317 169.338 197.107C169.338 197.107 168.981 202.381 168.981 208.526C168.981 214.671 169.338 219.945 169.338 219.945C157.77 215.729 147.538 215.36 140.438 215.428V235.983L140.438 235.985Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.282 279.047C119.793 279.047 112.033 300.936 112.033 300.936C112.033 300.936 107.727 290.557 95.906 290.557C87.9081 290.557 82.014 298.305 78.2671 305.48C92.8179 330.695 116.034 346.254 134.281 355.827C152.532 346.254 175.763 330.698 190.314 305.48C186.568 298.305 180.673 290.557 172.675 290.557C160.854 290.557 156.531 300.936 156.531 300.936C156.531 300.936 148.771 279.047 134.282 279.047H134.282Z",
    fill: "#2980B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.14f811adb013a42e42a8c538f3024dd8.svg";
export { ForwardRef as ReactComponent };